
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import logo from '../imgs/Bma logo.png'; // Adjust the path as necessary

const Navigation = () => {
  const { user, logout, isAuthenticated, isAdmin } = useAuth();

  const handleLogout = async () => {
    await logout();
  };
  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white shadow-lg border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo/Brand */}
          <div className="flex items-center">
            <Link to="/" className="flex items-center space-x-2">
              <div className="w-10 h-10">
                <img
                  src={logo}
                  alt="Blue and white BMA logo inside rounded square, representing Birth Records application branding"
                  
                />
              </div>
              <span className="text-xl font-bold text-gray-800">Birth Records</span>
            </Link>
          </div>
          
          {/* Right side navigation */}
          <div className="hidden md:flex items-center space-x-4">
            {isAdmin ? (
              <Link
                to="/admin-dashboard"
                className="text-gray-700 hover:text-blue-600 px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200"
              >
                Admin Dashboard
              </Link>
            ) : (
              <Link
                to="/"
                className="text-gray-700 hover:text-blue-600 px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200"
              >
                Dashboard
              </Link>
            )}
            
            <Link
              to="/add-record"
              className="text-gray-700 hover:text-blue-600 px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200"
            >
              Add Record
            </Link>

            <Link
              to="/search"
              className="text-gray-700 hover:text-blue-600 px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200"
            >
              Export Data
            </Link>
            
            {isAdmin && (
              <Link
                to="/edit-records"
                className="text-gray-700 hover:text-blue-600 px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200"
              >
                Edit Records
              </Link>
            )}

            {isAuthenticated && (
              <div className="relative">
                <button 
                  className="bg-gray-100 p-2 rounded-full text-gray-600 hover:text-gray-800 hover:bg-gray-200 transition-colors duration-200"
                  onClick={() => {
                    const userMenu = document.getElementById('user-menu');
                    userMenu.classList.toggle('hidden');
                  }}
                >
                  {isAdmin ? (
                    // Admin icon
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                    </svg>
                  ) : (
                    // Regular user icon
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                    </svg>
                  )}
                </button>
                {/* User dropdown menu */}
                <div id="user-menu" className="hidden absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-50">
                  <div className="px-4 py-2 text-sm text-gray-500 border-b border-gray-100">
                    {user?.full_name || user?.username}
                    <div className="text-xs text-gray-400 capitalize">{user?.role}</div>
                  </div>
                  {isAdmin && (
                    <Link
                      to="/admin"
                      className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                      onClick={() => document.getElementById('user-menu').classList.add('hidden')}
                    >
                      User Management
                    </Link>
                  )}
                  <button
                    onClick={handleLogout}
                    className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                  >
                    Logout
                  </button>
                </div>
              </div>
            )}
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              type="button"
              className="bg-gray-100 p-2 rounded-md text-gray-600 hover:text-gray-800 hover:bg-gray-200 transition-colors duration-200"
              onClick={() => {
                const mobileMenu = document.getElementById('mobile-menu');
                mobileMenu.classList.toggle('hidden');
              }}
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      <div className="md:hidden hidden" id="mobile-menu">
        <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-gray-50 border-t border-gray-200">
          {isAdmin ? (
            <Link
              to="/admin-dashboard"
              className="text-gray-700 hover:text-blue-600 block px-3 py-2 rounded-md text-base font-medium"
              onClick={() => document.getElementById('mobile-menu').classList.add('hidden')}
            >
              Admin Dashboard
            </Link>
          ) : (
            <Link
              to="/"
              className="text-gray-700 hover:text-blue-600 block px-3 py-2 rounded-md text-base font-medium"
              onClick={() => document.getElementById('mobile-menu').classList.add('hidden')}
            >
              Dashboard
            </Link>
          )}
          
          <Link
            to="/add-record"
            className="text-gray-700 hover:text-blue-600 block px-3 py-2 rounded-md text-base font-medium"
            onClick={() => document.getElementById('mobile-menu').classList.add('hidden')}
          >
            Add Record
          </Link>
          
          <Link
            to="/search"
            className="text-gray-700 hover:text-blue-600 block px-3 py-2 rounded-md text-base font-medium"
            onClick={() => document.getElementById('mobile-menu').classList.add('hidden')}
          >
            Export Data
          </Link>
          
          {isAdmin && (
            <Link
              to="/edit-records"
              className="text-gray-700 hover:text-blue-600 block px-3 py-2 rounded-md text-base font-medium"
              onClick={() => document.getElementById('mobile-menu').classList.add('hidden')}
            >
              Edit Records
            </Link>
          )}
          <div className="pt-4 pb-3 border-t border-gray-200">
            {isAuthenticated ? (
              <>
                <div className="px-3 py-2 text-sm text-gray-700 border-b border-gray-100 mb-2">
                  <div className="font-medium">{user?.full_name || user?.username}</div>
                  <div className="text-xs text-gray-500 capitalize flex items-center">
                    {isAdmin ? (
                      <>
                        <svg className="w-3 h-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                        </svg>
                        {user?.role}
                      </>
                    ) : (
                      <>
                        <svg className="w-3 h-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                        </svg>
                        {user?.role}
                      </>
                    )}
                  </div>
                </div>
                {isAdmin && (
                  <Link
                    to="/admin"
                    className="text-gray-700 hover:text-blue-600 block px-3 py-2 rounded-md text-base font-medium"
                    onClick={() => document.getElementById('mobile-menu').classList.add('hidden')}
                  >
                    User Management
                  </Link>
                )}
                <button
                  onClick={handleLogout}
                  className="text-red-600 hover:text-red-800 block px-3 py-2 rounded-md text-base font-medium w-full text-left"
                >
                  Logout
                </button>
              </>
            ) : (
              <Link
                to="/login"
                className="bg-blue-600 text-white block px-3 py-2 rounded-md text-base font-medium hover:bg-blue-700 transition-colors duration-200"
              >
                Login
              </Link>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
